import React from 'react'

import { Color } from '../../../../enums/color'
import { Icon } from '../../../Icon'
import * as Styled from './styles'

export const BreadcrumbSeparator = () => (
  <Styled.SeparatorWrapper>
    <Icon icon="chevronRight" color={Color.Grey300} />
  </Styled.SeparatorWrapper>
)
